export const PREVIOUS_TAX_YEARS_LOOKBACK = 5;

export const MONTH_OPTIONS = [
  { value: "JAN", label: "January" },
  { value: "FEB", label: "February" },
  { value: "MAR", label: "March" },
  { value: "APR", label: "April" },
  { value: "MAY", label: "May" },
  { value: "JUN", label: "June" },
  { value: "JUL", label: "July" },
  { value: "AUG", label: "August" },
  { value: "SEP", label: "September" },
  { value: "OCT", label: "October" },
  { value: "NOV", label: "November" },
  { value: "DEC", label: "December" },
];

export const MONTH_SOURCE_CLOSED = "CLOSED";
export const MONTH_SOURCE_FETCH = "FETCH";
export const MONTH_SOURCE_UPLOAD = "UPLOAD";
export const MONTH_SOURCE_MANUAL = "MANUAL";
export const MONTH_SOURCE_PROJECTED = "PROJECTED";
export const MONTH_SOURCE_NONE = "NONE";

export const ROW_TYPE_NORMAL = "normal";
export const ROW_TYPE_SECTION_HEADER = "section-header";
export const ROW_TYPE_SUB_HEADER = "sub-header";
export const ROW_TYPE_ADJ_ADDBACK = "adj-addback";
export const ROW_TYPE_ADJ_DEDUCTION = "adj-deduction";
export const ROW_TYPE_SECTION_TOTAL = "section-total";

export const ROW_SIGN_NEGATIVE = "negative";
export const ROW_SIGN_NEUTRAL = "neutral";

export const BREAKDOWN_ROW_KEY_FINANCIALS_SECTION = "__financials__";
export const BREAKDOWN_ROW_KEY_TOTAL_INCOME = "total_income";
export const BREAKDOWN_ROW_KEY_TOTAL_EXPENSES = "total_expenses";
export const BREAKDOWN_ROW_KEY_FIN_ADJ_SECTION = "__fin_adj_section__";
export const BREAKDOWN_ROW_KEY_TOTAL_NET_INCOME = "__total_net_income__";
export const BREAKDOWN_ROW_KEY_ADJ_SECTION = "__adj_section__";
export const BREAKDOWN_ROW_KEY_ADJ_ADDBACKS = "__adj_addbacks__";
export const BREAKDOWN_ROW_KEY_ADJ_DEDUCTIONS = "__adj_deductions__";
export const BREAKDOWN_ROW_KEY_S174_ADDBACK = "s174_addback";
export const BREAKDOWN_ROW_KEY_TOTAL_ADJUSTMENT = "__total_adjustment__";
export const BREAKDOWN_ROW_KEY_TAXABLE_INCOME_SECTION =
  "__taxable_income_section__";
export const BREAKDOWN_ROW_KEY_PENDING_NOL = "pending_nol";
export const BREAKDOWN_ROW_KEY_USED_NOL = "used_nol";
export const BREAKDOWN_ROW_KEY_TOTAL_TAXABLE_INCOME =
  "__total_taxable_income__";
export const BREAKDOWN_ROW_KEY_FEDERAL_TAX = "federal_tax";

const CURRENT_YEAR = new Date().getFullYear();
const YEARS_BACK = 10;

export const YEAR_OPTIONS = Array.from({ length: YEARS_BACK + 1 }, (_, i) => {
  const year = CURRENT_YEAR - i;
  return { value: String(year), label: String(year) };
});
